import { render, staticRenderFns } from "./RecuperarContrasenaComponent.vue?vue&type=template&id=584ba923&"
import script from "./RecuperarContrasenaComponent.vue?vue&type=script&lang=js&"
export * from "./RecuperarContrasenaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports